const BYTES_PER_KB = 1024
const BYTES_PER_MB = BYTES_PER_KB * 1024
const BYTES_PER_GB = BYTES_PER_MB * 1024

/**
 * Format byte count as KB, MB, or GB with appropriate decimals.
 */
export function formatBytes(bytes?: number | null): string {
  const value = Number(bytes ?? 0)
  if (value === 0) return '0 B'
  if (value < BYTES_PER_KB) return `${value} B`
  if (value < BYTES_PER_MB) return `${(value / BYTES_PER_KB).toFixed(2)} KB`
  if (value < BYTES_PER_GB) return `${(value / BYTES_PER_MB).toFixed(2)} MB`
  return `${(value / BYTES_PER_GB).toFixed(2)} GB`
}
